import { useState } from 'react';
import { DialogFooter, DialogHeader, DialogTitle } from '../../../../common/components/ui/dialog';
import { Button } from '../../../../common/components/ui/button';
import { abortUserInputForCart } from '../../actions/cartActions';
import { useTranslation } from 'react-i18next';
import { CartDialogConfirmCancel } from '../shared/CartDialogConfirmCancel';
import { useCartErrorNotification } from '../../state-hooks/useCartErrorNotification';
import { toKeyedItems } from '../../../../common/utils/keyedItems';

export function CartDialogMessages() {
  const { t } = useTranslation();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const { messages } = useCartErrorNotification();

  if (showConfirmation) {
    return <CartDialogConfirmCancel onBack={() => setShowConfirmation(false)} />;
  }

  return (
    <>
      <DialogHeader>
        <DialogTitle className={'flex items-center'}>{t('Meldung')}</DialogTitle>
      </DialogHeader>
      <div>
        {toKeyedItems(messages).map(({ key, item: message }) => (
          <div key={key}>{message}</div>
        ))}
      </div>
      <DialogFooter className={'flex-col desktop:flex-row gap-4 desktop:gap-1'}>
        <Button
          variant={'primaryOutline'}
          onClick={() => setShowConfirmation(true)}
          data-testid={'cart-discard-button'}
        >
          {t('Warenkorb verwerfen')}!
        </Button>
        <Button onClick={abortUserInputForCart} data-testid={'cart-ok-button'}>
          {t('Verstanden')}
        </Button>
      </DialogFooter>
    </>
  );
}
